import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PaginationUtil } from 'src/app/common/util';
import { PaginationModel } from 'src/app/models/pagination.model';
import { ProductService } from 'src/app/services/product.service';
@Component({
  selector: 'app-inventory-cost',
  templateUrl: './inventory-cost.component.html',
  styleUrls: ['./inventory-cost.component.scss']
})
export class InventoryCostComponent {
startDate: string;
  endDate: string;
  paginationProviders = new PaginationModel(0, 5, 0, 0, [], []);
  titles = [
    'Ingreso', 'Egreso', 'Diferencia'
  ];
  filterProducts = [];
  products = [];
  inputs = {
    product: {
      value: '',
      verified: false,
      required: false,
      message: '-',
      class: '',
      color: '',
      tooltip: 'status-product',
      data: null
    }
  };
  timeout = null;
  allProductsSelected = false;
  sortColumn: string = '';
  sortDirection: string = '';


  constructor(
    private productService: ProductService,
    private toastService: ToastrService,
  ) {}

  ngOnInit(): void {
    this.getProducts();
  }

  loadProviders() {
    // Mock data
    const data = [
      {
        name: 'COMERCIALIZADORA ELECTRICA FERRETERA, S.A.',
        expanded: false,
        monthlySales: { 'Ingreso': { venta: 43500, utilidad: 10400, total:7000 } },
        totalVenta: 53900,
        totalUtilidad: 64300,
        warehouses: [
          {
            name: 'Sucursal 1',
            expanded: false,
            monthlySales: { 'Ingreso': { venta: 21500, utilidad: 5200, total:7000 } },
            totalVenta: 21500,
            totalUtilidad: 5200,
            products: [
              { name: 'Producto 1', monthlySales: { 'Ingreso': { venta: 5000, utilidad: 2000, total:7000 } }, totalVenta: 5000, totalUtilidad: 2000 },
              { name: 'Producto 2', monthlySales: { 'Ingreso': { venta: 4000, utilidad: 1500, total:5500 } }, totalVenta: 4000, totalUtilidad: 1500 }
            ]
          },
          {
            name: 'Sucursal 2',
            expanded: false,
            monthlySales: { 'Ingreso': { venta: 22000, utilidad: 5200, total:50000 } ,'Egreso': { venta: 22000, utilidad: 5200, total:50001 } },
            totalVenta: 22000,
            totalUtilidad: 5200,
            products: [
              { name: 'Producto 3', monthlySales: { 'Ingreso': { venta: 10000, utilidad: 2500, total:50003 } }, totalVenta: 10000, totalUtilidad: 2500 },
              { name: 'Producto 4', monthlySales: { 'Ingreso': { venta: 12000, utilidad: 2700, total:50004 },'Egreso': { venta: 12000, utilidad: 22000, total:50005 } }, totalVenta: 52000, totalUtilidad: 2700,  }
            ]
          }
        ]
      },
      {
        name: 'INDUSTRIAS TECNICAS S.A.',
        expanded: false,
        monthlySales: { 'Ingreso': { venta: 32000, utilidad: 8000, total:7000 } },
        totalVenta: 32000,
        totalUtilidad: 8000,
        warehouses: [
          {
            name: 'Sucursal 3',
            expanded: false,
            monthlySales: { 'Ingreso': { venta: 17000, utilidad: 4200, total:7000 } },
            totalVenta: 17000,
            totalUtilidad: 4200,
            products: [
              { name: 'Producto 5', monthlySales: { 'Ingreso': { venta: 8000, utilidad: 2000, total:50000 } }, totalVenta: 8000, totalUtilidad: 2000 },
              { name: 'Producto 6', monthlySales: { 'Ingreso': { venta: 9000, utilidad: 2200, total:50000 } }, totalVenta: 9000, totalUtilidad: 2200 }
            ]
          },
          {
            name: 'Sucursal 4',
            expanded: false,
            monthlySales: { 'Ingreso': { venta: 15000, utilidad: 3800, total:7000 } },
            totalVenta: 15000,
            totalUtilidad: 3800,
            products: [
              { name: 'Producto 7', monthlySales: { 'Ingreso': { venta: 7000, utilidad: 1800, total:50000 } }, totalVenta: 7000, totalUtilidad: 1800 },
              { name: 'Producto 8', monthlySales: { 'Ingreso': { venta: 8000, utilidad: 2000, total:50000 } }, totalVenta: 8000, totalUtilidad: 2000 }
            ]
          }
        ]
      },
      {
        name: 'COMERCIALIZADORA GLOBAL S.A.',
        expanded: false,
        monthlySales: { 'Ingreso': { venta: 50000, utilidad: 12000, total:7000 } },
        totalVenta: 50000,
        totalUtilidad: 12000,
        warehouses: [
          {
            name: 'Sucursal 5',
            expanded: false,
            monthlySales: { 'Ingreso': { venta: 25000, utilidad: 6000, total:7000 } },
            totalVenta: 25000,
            totalUtilidad: 6000,
            products: [
              { name: 'Producto 9', monthlySales: { 'Ingreso': { venta: 12000, utilidad: 3000, total:50000 } }, totalVenta: 12000, totalUtilidad: 3000 },
              { name: 'Producto 10', monthlySales: { 'Ingreso': { venta: 13000, utilidad: 3000, total:50000 } }, totalVenta: 13000, totalUtilidad: 3000 }
            ]
          },
          {
            name: 'Sucursal 6',
            expanded: false,
            monthlySales: { 'Ingreso': { venta: 25000, utilidad: 6000, total:7000 } },
            totalVenta: 25000,
            totalUtilidad: 6000,
            products: [
              { name: 'Producto 11', monthlySales: { 'Ingreso': { venta: 11000, utilidad: 2800, total:50000 } }, totalVenta: 11000, totalUtilidad: 2800 },
              { name: 'Producto 12', monthlySales: { 'Ingreso': { venta: 14000, utilidad: 3200, total:50000 } }, totalVenta: 14000, totalUtilidad: 3200 }
            ]
          }
        ]
      }
    ];

    this.paginationProviders.total = data;
    this.paginationProviders = PaginationUtil.reset(this.paginationProviders);
  }

  getProducts() {
    this.productService.getProductsPurchase('').subscribe(
      (response) => {
        this.products = Object(response)['data'].map(p => ({ ...p, selected: false }));
        this.filterProducts = this.products;
      },
      (error) => {
        console.error(error.error.message);
      }
    );
  }

  toggleProvider(provider: any) {
    provider.expanded = !provider.expanded;
  }

  toggleWarehouse(warehouse: any, event: MouseEvent) {
    event.stopPropagation(); // Evita que se expanda el producto al hacer clic en el warehouse
    warehouse.expanded = !warehouse.expanded;
  }

  toggleSelectAllProducts() {
    this.allProductsSelected = !this.allProductsSelected;
    this.products.forEach(p => p.selected = this.allProductsSelected);
    this.filterProducts.forEach(p => p.selected = this.allProductsSelected);
  }

  verifiedInput(event: any, type: string) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (type === 'product') {
      let temp: any = this.products.filter((product) =>
        product.name.toLowerCase().includes(inputValue.toLowerCase()) ||
        product.id == parseInt(inputValue)
      );
      if (temp.length === 1) {
        this.changeStatusInput(temp[0], (temp[0].barCode ? temp[0].barCode + ' - ' : '') + temp[0].name, 1, 'product');
      } else {
        this.changeStatusInput(null, null, 0, 'product');
      }
    }
  }

  handleInput(event: any, type: string) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (type === 'product') {
      clearTimeout(this.timeout);
      this.inputs.product.class = "typing";
      this.timeout = setTimeout(() => {
        this.filterProducts = this.products.filter((product) =>
          product.name.toLowerCase().includes(inputValue.toLowerCase()) ||
          product.id == parseInt(inputValue)
        );
        if (this.filterProducts.length === 0) {
          this.changeStatusInput(null, null, 0, 'product');
        } else {
          this.inputs.product.class = "bx bx-list-check";
        }
      }, 500);
    }
  }

  changeStatusInput(selected: any, newValue: string, status: number, type: string) {
    let tempInput = this.inputs[type];
    tempInput.verified = status === 1;
    if (status === 1) {
      tempInput.data = selected;
      tempInput.value = newValue;
      tempInput.color = "success";
      tempInput.class = 'fa-check';
    } else {
      tempInput.data = null;
      tempInput.color = 'danger';
      tempInput.class = (status === 0) ? 'fa-xmark' : 'fa-asterisk';
    }
  }

  executeSearch() {
    const selectedProducts = this.products.filter(p => p.selected);
    const selectedIds = selectedProducts.map(p => p.id);
    console.log("Productos seleccionados:", selectedIds);
    if(this.validateInputs(selectedIds)){
      // realizar la busqueda
      // this.loadProviders();
      this.toastService.info("Busqueda realizada");
    }
  }

  validateInputs(selectedIds:any){
    if(selectedIds.length <= 0){
      this.toastService.error("Debe seleccionar almenos un producto para realizar la busqueda");
      return false;
    }
    if(this.startDate == null || this.startDate == undefined){
      this.toastService.error("Debe seleccionar la fecha de inicio para realizar la busqueda");
      return false;
    }
    if(this.endDate == null || this.endDate == undefined){
      this.toastService.error("Debe seleccionar la fecha de fin para realizar la busqueda");
      return false;
    }
    return true;
  }

  getTotalVenta(title: string): number {
    let total = 0;
    for (const provider of this.paginationProviders.filter) {
      total += provider.monthlySales[title]?.venta || 0;
    }
    return total;
  }

  getTotalUtilidad(title: string): number {
    let total = 0;
    for (const provider of this.paginationProviders.filter) {
      total += provider.monthlySales[title]?.utilidad || 0;
    }
    return total;
  }

  getTotalTotal(title: string): number {
    let total = 0;
    for (const provider of this.paginationProviders.filter) {
      total += provider.monthlySales[title]?.total || 0;
    }
    return total;
  }

  sortByDynamicColumn(title: string, type: 'venta' | 'utilidad' | 'total') {
    const columnKey = `${title}_${type}`;
    
    if (this.sortColumn === columnKey) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = columnKey;
      this.sortDirection = 'asc';
    }

    this.paginationProviders.filter.sort((a, b) => {
      const valueA = a.monthlySales[title]?.[type] || 0;
      const valueB = b.monthlySales[title]?.[type] || 0;

      if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }

}
